// extracted by mini-css-extract-plugin
module.exports = {"categoryMark":"CategoryMark_categoryMark__E_rwh","hot":"CategoryMark_hot__2me16","new":"CategoryMark_new__88CCD"};